import React from 'react'
import { SideEffectFieldsFragment } from '../../../graphql'
import NivoChart from './NivoChart'
import RechartsChart from './RechartsChart'
import { LinearProgress } from '@mui/material'

const ChartResults: React.FC<{ config: SideEffectFieldsFragment['data'] }> = ({ config }) => {
  const chartLibrary = config.chartLibrary || 'nivo'

  const loading = !config || Object.keys(config).length === 0
  return (
    <div className="flex flex-row justify-start max-w-2xl bg-white rounded-lg p-4">
      {chartLibrary === 'nivo' && <NivoChart config={config} />}
      {chartLibrary == 'rechart' && <RechartsChart config={config} />}
      {loading && <LinearProgress />}
    </div>
  )
}

export default ChartResults
